export default function DialBackFooter() {
  return (
    <footer
      className="border-t border-white/[0.06] px-12 py-10 flex items-center justify-between flex-wrap gap-4 max-md:px-6 max-md:flex-col max-md:text-left"
      style={{ background: '#0e0d0b', fontFamily: "'Instrument Sans', sans-serif" }}
    >
      <div
        className="text-[12px] text-[#9a9488]"
        style={{ fontFamily: "'DM Mono', monospace" }}
      >
        <span className="text-[#c8472a]">dial-back</span> · by Delegate · Jessica AI
      </div>
      <div className="text-[0.78rem] text-[rgba(154,148,136,0.6)] max-w-[500px] leading-[1.5] text-right max-md:text-left">
        Introductory beta offer. Feature roadmap and pricing subject to change based on beta feedback. Recording and summary features pricing coming soon.
      </div>
    </footer>
  );
}
